import {Component, EventEmitter, Input, OnDestroy, Output} from '@angular/core';
import {NavBaseComponent} from '../nav-base/nav-base.component';
import {AppUtils} from '../../shared/app-utils';
import {ActivatedRoute, Router} from '@angular/router';
import {FormControl} from '@angular/forms';
import {HtmlUtilsService} from "../../html-utils/html-utils.service";
import {TranslateService} from '../../shared/translate.service';
import {Subscription} from "rxjs";
import {GoogleAnalyticsService} from '../../shared/google-analytics.service';
import {environment} from "../../../environments/environment";

export enum AutoCompleteAction {
  ARROW_UP,
  ARROW_DOWN,
  ENTER
}

@Component({
  selector: 'app-nav-search',
  templateUrl: './nav-search.component.html',
  styleUrls: ['../nav-base/nav-base.component.scss', './nav-search.component.css']
})
export class NavSearchComponent extends NavBaseComponent {

  private fulltextBaseUrl = environment.fulltextUrl

  @Input() phrase: string;

  @Output() showSearchEmitter = new EventEmitter<boolean>();

  autoCompleteActionEmitter = new EventEmitter<AutoCompleteAction>();

  phraseField = new FormControl();

  focused = false;

  hasSuggest = false;

  suggestNumber = 0;

  hasFocusSuggest = false;

  manualAutoCompleteClose = false;

  _searchInText = false;

  set searchInText(value: boolean) {
    if(this._searchInText !== value){
      this._searchInText = value;
      this.htmlUtils.searchInText = value;
    }
  }

  get searchInText() {
    return this._searchInText;
  }

  private showSearch = false;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private htmlUtils: HtmlUtilsService,
    public translateService: TranslateService,
    public googleAnalyticsService: GoogleAnalyticsService) {
    super();
  }

  ngOnInit() {
    super.ngOnInit();

    this.searchInText = this.route.snapshot.queryParamMap.get('searchInText') === 'true';

    this.phraseField.valueChanges.subscribe(value => {
      this.phrase = value;
    });

  }

  markFocused() {
    this.focused = true;
  }

  markBlured() {
    this.focused = false;
    this.manualAutoCompleteClose = false;
  }

  onSubmit() {
    if (this.searchInText){
      this.googleAnalyticsService.trackSearchTerms(this.phrase);
      this.htmlUtils.searchInTextEmitter.emit(this.searchInText);
      this.phraseField.setValue(null);
      this.redirectToFulltext(this.phrase);
    } else {
      const targetPage = '/search/s/';
      let filters = AppUtils.phraseToFilter(this.phrase).toURL();
      filters = filters.concat(',_type:-work');
      this.googleAnalyticsService.trackSearchTerms(this.phrase);
      this.htmlUtils.searchInTextEmitter.emit(this.searchInText);
      this.router.navigate([targetPage], {
        queryParams: {page: 1, searchInText: this._searchInText, filters, phrase: this.phrase}
      });
      this.phraseField.setValue(null);
    }
  }

  toggleSearch() {
    this.showSearch = !this.showSearch;
    this.showSearchEmitter.emit(this.showSearch);
  }

  canShowAutoComplete() {
    return this.focused && this.hasSuggest && !this.searchInText && !this.manualAutoCompleteClose;
  }

  triggerArrowDown() {
    if (this.manualAutoCompleteClose) {
      this.manualAutoCompleteClose = false;
    } else {
      this.autoCompleteActionEmitter.emit(AutoCompleteAction.ARROW_DOWN);
    }
  }

  triggerArrowUp() {
    if (this.canShowAutoComplete()) {
      this.autoCompleteActionEmitter.emit(AutoCompleteAction.ARROW_UP);
    }
  }

  triggerEnter(event) {
    if (this.canShowAutoComplete() && this.hasFocusSuggest) {
      event.preventDefault();
      this.autoCompleteActionEmitter.emit(AutoCompleteAction.ENTER);
    }
  }

  getAriaLabel() {
    if (this.canShowAutoComplete()) {
      return this.translateService.translate('home.suggeston.count') + ' ' + this.suggestNumber;
    } else {
      return this.translateService.translate('home.suggeston.aria.label');
    }
  }

  redirectToFulltext(phrase: string) {
    window.location.href = `${this.fulltextBaseUrl}/results?query=${phrase}`;
  }
}
